export default "__VITE_ASSET__BZSC7uTK__"